import { CollectionCard } from "@/components/collections/CollectionCard";

interface TabArchiveLookProps {
  collectionIds: string[];
  showAvatar?: boolean;
}

export function TabArchiveCollection({ collectionIds, showAvatar = true }: TabArchiveLookProps) {
  return (
    <div className="grid grid-cols-2 gap-2 px-2 mt-4">
      {collectionIds?.map((collectionId) => (
        <CollectionCard key={collectionId} collectionId={collectionId} variant="default" showAvatar={showAvatar} />
      ))}
    </div>
  );
}
